import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import { Row, Col, Dropdown, DropdownToggle, DropdownMenu } from "reactstrap";

function Header() {
  // Redux (From store)
  const log_data = useSelector((state) => state.logged.loginData);
  const navigate = useNavigate();
  const [menuStates, setMenuStates] = useState({ m1: false, m2: false, m3: false, m4: false });

  // Redirect to login if not logged in
  useEffect(() => {
    if (log_data.login !== true) {
      sessionStorage.clear();
      localStorage.clear();
      navigate("/");
    }
  }, [log_data, navigate]);

  // Sign out function
  function signOutClickHandler() {
    sessionStorage.clear();
    localStorage.clear();
    navigate("/");
  }

  // Toggle menu visibility
  function toggleMenu(menuKey) {
    setMenuStates((prevState) => ({
      ...prevState,
      [menuKey]: !prevState[menuKey],
    }));
  }

  return (
    <div className="headerPage">
      <Row>
        <Col xs={9} className="p-2">
          <div className="justify-content-start align-items-center h-100 d-none d-md-flex">
            {/* Home Button */}
            <div className="d_menu">
            <Link to="/Home" style={{ textDecoration: "none", color: "inherit" }}>
  Home
</Link>
            </div>

            {/* Other Dropdown Menus */}
            {["Raw Material", "Finished Product", "Batch", "Master"].map((menu, index) => (
              <Dropdown
                key={menu}
                isOpen={menuStates[`m${index + 1}`]}
                onMouseEnter={() => toggleMenu(`m${index + 1}`)}
                onMouseLeave={() => toggleMenu(`m${index + 1}`)}
              >
                <DropdownToggle
                  className={`d_menu ${menuStates[`m${index + 1}`] && "bg-primary text-white"}`}
                  data-toggle="dropdown"
                  tag="span"
                >
                  {menu}
                </DropdownToggle>
                <DropdownMenu>
                  {menu === "Raw Material" && (
                    <>
                      <div className="d_menuItem">
                        <Link to="/CreateRaw" className="menu-link">Add Raw Material</Link>
                      </div>
                      <div className="d_menuItem">
                        <Link to="/ViewRaw" className="menu-link">Raw Material List</Link>
                      </div>
                      <div className="d_menuItem">
                        <Link to="/RawStockIn" className="menu-link">Stock In Raw Material</Link>
                      </div>
                      <div className="d_menuItem">
                        <Link to="/RawStockOut" className="menu-link">Stock Out Raw Material</Link>
                      </div>
                    </>
                  )}
                  {menu === "Finished Product" && (
                    <>
                      <div className="d_menuItem">
                        <Link to="/FinishedStockIn" className="menu-link">Stock in Finished Product</Link>
                      </div>
                      <div className="d_menuItem">
                        <Link to="/FinishedStockOut" className="menu-link">Stock Out Finished Product</Link>
                      </div>
                      <div className="d_menuItem">
                        <Link to="/ViewFinished" className="menu-link">Finished Product List</Link>
                      </div>
                    </>
                  )}
                  {menu === "Batch" && (
                    <>
                      <div className="d_menuItem">
                        <Link to="/ViewBatch" className="menu-link">Current Batch</Link>
                      </div>
                    </>
                  )}
                  {menu === "Master" && (
                    <>
                      <div className="d_menuItem">
                        <Link to="/ViewVendor" className="menu-link">View Vendor</Link>
                      </div>
                      <div className="d_menuItem">
                        <Link to="/CreateVendor" className="menu-link">Create Vendor</Link>
                      </div>
                      <div className="d_menuItem">
                        <Link to="/ViewCustomer" className="menu-link">View Customer</Link>
                      </div>
                      <div className="d_menuItem">
                        <Link to="/CreateCustomer" className="menu-link">Create Customer</Link>
                      </div>
                    </>
                  )}
                </DropdownMenu>
              </Dropdown>
            ))}

            <div className="d_menu" onClick={() => signOutClickHandler()}>
              Signout
            </div>
          </div>
        </Col>

        <Col xs={3} className="d-flex align-items-center justify-content-end">
          <h5 className="text-primary m-0 me-4">
            <b>Shiva Enterprises</b>
          </h5>
        </Col>
      </Row>
    </div>
  );
}

export default Header;
